import { render } from "./table-cell-identifier.vue?vue&type=template&id=6a299738"
import script from "./table-cell-identifier.vue?vue&type=script&lang=js"
export * from "./table-cell-identifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__